import puppeteer, { type Browser } from "puppeteer-core";

import { detectBrowser } from "./detectBrowser";
import { PdfEngineError, type DetectedBrowser } from "../types/types";

export type LaunchBrowserOptions = {
  executablePath?: string;
};

export type LaunchedBrowser = {
  browser: Browser;
  detectedBrowser: DetectedBrowser;
};

export async function launchBrowser(
  options: LaunchBrowserOptions = {}
): Promise<LaunchedBrowser> {
  const detectedBrowser = detectBrowser(
    options.executablePath ? { executablePath: options.executablePath } : {}
  );

  try {
    const browser = await puppeteer.launch({
      executablePath: detectedBrowser.executablePath,
      headless: true,
      args: [
        "--disable-dev-shm-usage",
        "--disable-background-networking",
        "--disable-default-apps",
        "--disable-extensions"
      ]
    });

    return {
      browser,
      detectedBrowser
    };
  } catch (error) {
    throw new PdfEngineError(
      "BROWSER_LAUNCH_FAILED",
      `Failed to launch ${detectedBrowser.name} for PDF rendering.`,
      {
        cause: error,
        details: detectedBrowser
      }
    );
  }
}
